import { useEffect } from "react";

import { useSearchParams } from "react-router-dom";

import {
  setAmplitudeDeviceId,
  setAmplitudeUserProperties,
} from "client/lib/amplitude";
import {
  getExperimentVariantFromUrlParams,
  Variant,
} from "client/splitTests/hubSignUp";

import { useLocalStorageState } from "./useLocalStorageState";

// Utility function to remove specified search parameters and update the URL
const removeSearchParams = (
  searchParams: URLSearchParams,
  setSearchParams: any,
  keys: string[]
): void => {
  keys.forEach((key) => {
    if (searchParams.has(key)) {
      searchParams.delete(key);
    }
  });
  const queryString = searchParams.toString();
  setSearchParams(queryString);
};
const useExperimentGroup = (): Variant | null => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [
    hubSignUpExperimentGroup,
    setHubSignUpExperimentGroup,
  ] = useLocalStorageState("hubSignUpExperimentGroup", null);

  useEffect(() => {
    const experimentGroup = getExperimentVariantFromUrlParams(
      "ob",
      searchParams
    );

    const deviceId = searchParams.get("deviceId");

    if (deviceId) {
      setAmplitudeDeviceId(deviceId);
      searchParams.delete("deviceId");
    }

    if (experimentGroup) {
      setAmplitudeUserProperties({ hubSignUpExperimentGroup: experimentGroup });
      setHubSignUpExperimentGroup(experimentGroup);
      searchParams.delete("ob");
    }

    // Remove param from url once we've set user property or remove invalid param values
    removeSearchParams(searchParams, setSearchParams, ["ob", "deviceId"]);
  }, [searchParams, setSearchParams, setHubSignUpExperimentGroup]);

  return hubSignUpExperimentGroup;
};

export default useExperimentGroup;
